module.exports = __webpack_public_path__ + "img/Products_Portrait_White_500px.2fd5e06d.jpg";